export const genPayloadId = () => {
  const thousand = 1000
  const date = new Date().getTime() * thousand
  const extra = Math.floor(Math.random() * thousand)

  return date + extra
}
